"use strict";

var _toConsumableArray = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _regeneratorRuntime = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/regenerator/index.js");

var _defineProperty = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/defineProperty.js");

var _asyncToGenerator = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/createClass.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var algoliasearch_1 = __importDefault(require("algoliasearch"));

var dayjs_1 = __importDefault(require("dayjs"));

var firestore_1 = require("firebase/firestore");

var lodash_1 = require("lodash");

var firebase_1 = require("../../config/firebase");

var functions_1 = require("../../utils/functions");

var initializeValues_1 = __importDefault(require("../../utils/initializeValues"));

var requiredData_1 = __importDefault(require("../../utils/requiredData"));

var functions_2 = require("../functions");

var Model = /*#__PURE__*/function () {
  function Model(props) {
    var _this = this;

    _classCallCheck(this, Model);

    this.wheres = {};

    this.allRequiredIsValid = function (values) {
      var requiredKeys = _this.extractRequiredAttributes();

      Object.keys(requiredKeys).forEach(function (key) {
        if (requiredKeys[key] && 'boolean' === typeof requiredKeys[key]) {
          if (!values || !values[key]) {
            throw new Error("".concat(key, " obligatoire"));
          }
        }
      });
      return true;
    };

    var addButtonLabel = props.addButtonLabel,
        collectionName = props.collectionName,
        datas = props.datas,
        firebase = props.firebase,
        orderDirection = props.orderDirection,
        orderField = props.orderField,
        params = props.params,
        parentCollectionName = props.parentCollectionName,
        parentId = props.parentId,
        tabs = props.tabs,
        title = props.title,
        wheres = props.wheres;

    if (!collectionName) {
      throw new Error('collectionName obligatoire');
    }

    this.addButtonLabel = addButtonLabel || 'Ajouter';
    this.collectionName = collectionName;
    this.datas = datas;
    this.firebase = firebase;
    this.orderDirection = orderDirection || 'desc';
    this.orderField = orderField || 'datetime';
    this.params = params || {};
    this.parentCollectionName = parentCollectionName;
    this.parentId = parentId;
    this.tabs = tabs && !Array.isArray(tabs) ? [tabs] : tabs;
    this.title = title || 'name';
    this.wheres = wheres || {};
  }

  _createClass(Model, [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
        var user, docRef;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                user = firebase_1.auth.currentUser;

                if (user) {
                  _context.next = 3;
                  break;
                }

                throw new Error("L'utilisateur doit être connecté pour enregistrer un document");

              case 3:
                _context.next = 5;
                return (0, firestore_1.addDoc)(this.getCollectionRef(), this.clean(_objectSpread({
                  createdByUser: user.uid
                }, data), true));

              case 5:
                docRef = _context.sent;
                return _context.abrupt("return", (0, firestore_1.getDoc)(docRef).then(function (documentSnapshot) {
                  return _objectSpread({
                    id: documentSnapshot.id
                  }, documentSnapshot.data());
                }));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function create(_x) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "delete",
    value: function _delete(id) {
      var user = firebase_1.auth.currentUser;

      if (!user) {
        throw new Error("L'utilisateur doit être connecté pour supprimer un document");
      }

      var date = (0, dayjs_1.default)().toISOString();
      var ref = (0, firestore_1.doc)(this.getCollectionRef(), id);
      return (0, firestore_1.updateDoc)(ref, {
        deleted: true,
        deletedAt: date,
        updatedAt: date,
        updatedByUser: user.uid
      });
    }
  }, {
    key: "duplicate",
    value: function () {
      var _duplicate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id, data) {
        var docRef;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (data) {
                  _context2.next = 2;
                  break;
                }

                throw new Error('Le document a dupliqué ne possède aucune donnée');

              case 2:
                docRef = (0, firestore_1.doc)(this.getFirestore(), this.collectionName);
                _context2.next = 5;
                return (0, firestore_1.setDoc)(docRef, this.clean(_objectSpread(_objectSpread({}, data), {}, {
                  parent: id
                }), true));

              case 5:
                return _context2.abrupt("return", docRef);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function duplicate(_x2, _x3) {
        return _duplicate.apply(this, arguments);
      }

      return duplicate;
    }()
  }, {
    key: "getCollectionRef",
    value: function getCollectionRef() {
      var path = this.collectionName;
      var paths = [];

      if (this.parentId && this.parentCollectionName) {
        path = this.parentCollectionName;
        paths.push(this.parentId);
        paths.push(this.collectionName);
      }

      return (0, firestore_1.collection).apply(void 0, [this.getFirestore(), path].concat(paths));
    }
  }, {
    key: "getFirestore",
    value: function getFirestore() {
      return firebase_1.firestore;
    }
  }, {
    key: "getParams",
    value: function getParams() {
      return this.datas || this.params;
    }
  }, {
    key: "initialize",
    value: function initialize(data) {
      var initializeData = this.initializeData(data);
      return this.clean(initializeData);
    }
  }, {
    key: "initializeData",
    value: function initializeData(data) {
      var datas = (0, initializeValues_1.default)(this.getParams());
      return _objectSpread(_objectSpread({}, datas), data);
    }
  }, {
    key: "extractAttributes",
    value: function extractAttributes(data, initialValues) {
      var attributes = {};
      var initializedData = initialValues || (0, initializeValues_1.default)(this.getParams());
      Object.keys(initializedData).forEach(function (key) {
        attributes[key] = data[key];
      });
      return attributes;
    }
  }, {
    key: "extractRequiredAttributes",
    value: function extractRequiredAttributes() {
      return (0, requiredData_1.default)(this.getParams());
    }
  }, {
    key: "find",
    value: function () {
      var _find = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(options) {
        var _a, constaints, q, querySnapshot;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                constaints = [(0, firestore_1.where)('deleted', '==', false)];
                constaints = (0, functions_2.updateConstraints)(constaints, {
                  orderDirection: (options === null || options === void 0 ? void 0 : options.orderDirection) || this.orderDirection,
                  orderField: (options === null || options === void 0 ? void 0 : options.orderField) || this.orderField,
                  wheres: (options === null || options === void 0 ? void 0 : options.wheres) ? (0, lodash_1.mergeWith)(options.wheres, this.wheres) : this.wheres
                });

                if (options === null || options === void 0 ? void 0 : options.startAfter) {
                  constaints.push((0, firestore_1.startAfter)(options.startAfter));
                }

                constaints.push((0, firestore_1.limit)((_a = options === null || options === void 0 ? void 0 : options.limit) !== null && _a !== void 0 ? _a : parseInt(String(process.env.GATSBY_INNEDIT_WATCH_LIMIT), 10) || 250));
                q = (0, firestore_1.query).apply(void 0, [this.getCollectionRef()].concat(_toConsumableArray(constaints)));
                _context3.next = 7;
                return (0, firestore_1.getDocs)(q);

              case 7:
                querySnapshot = _context3.sent;
                return _context3.abrupt("return", querySnapshot.docs.map(function (d) {
                  return _objectSpread({
                    id: d.id
                  }, d.data());
                }));

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function find(_x4) {
        return _find.apply(this, arguments);
      }

      return find;
    }()
  }, {
    key: "findById",
    value: function () {
      var _findById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(id) {
        var documentSnapshot;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return (0, firestore_1.getDoc)((0, firestore_1.doc)(this.getCollectionRef(), id));

              case 2:
                documentSnapshot = _context4.sent;

                if (!(!documentSnapshot || !documentSnapshot.exists() || documentSnapshot.get('deleted'))) {
                  _context4.next = 5;
                  break;
                }

                throw new Error("Le document n'existe pas ou a été supprimé");

              case 5:
                return _context4.abrupt("return", _objectSpread({
                  id: id
                }, documentSnapshot.data()));

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function findById(_x5) {
        return _findById.apply(this, arguments);
      }

      return findById;
    }()
  }, {
    key: "findByIds",
    value: function () {
      var _findByIds = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(ids) {
        var _this2 = this;

        var q, querySnapshot;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                q = (0, firestore_1.query)(this.getCollectionRef(), (0, firestore_1.where)((0, firestore_1.documentId)(), 'in', ids));
                _context5.next = 3;
                return (0, firestore_1.getDocs)(q);

              case 3:
                querySnapshot = _context5.sent;
                return _context5.abrupt("return", querySnapshot.docs.sort(function (a, b) {
                  var aField = a.get(_this2.orderField);
                  var bField = b.get(_this2.orderField);

                  if ('asc' === _this2.orderDirection) {
                    if ('string' === typeof aField) {
                      return aField.localeCompare(bField);
                    }

                    return aField - bField;
                  }

                  if ('string' === typeof aField) {
                    return bField.localeCompare(aField);
                  }

                  return bField - aField;
                }).map(function (d) {
                  return _objectSpread({
                    id: d.id
                  }, d.data());
                }));

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function findByIds(_x6) {
        return _findByIds.apply(this, arguments);
      }

      return findByIds;
    }()
  }, {
    key: "search",
    value: function () {
      var _search = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(q) {
        var options,
            defaultNbParPage,
            algoliaIndexName,
            index,
            wheres,
            searchResponse,
            _args6 = arguments;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                options = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : {};
                defaultNbParPage = 40;
                algoliaIndexName = String(process.env.GATSBY_ALGOLIA_INDEX_NAME).toUpperCase();
                index = "".concat(this.collectionName, "_").concat(algoliaIndexName);
                wheres = options.wheres ? (0, lodash_1.mergeWith)(options.wheres, this.wheres) : this.wheres;
                _context6.next = 7;
                return (0, algoliasearch_1.default)(String(process.env.GATSBY_ALGOLIA_APP_ID), String(process.env.GATSBY_ALGOLIA_SEARCH_KEY)).initIndex(index).search(q, _objectSpread(_objectSpread({}, options.params), {}, {
                  analytics: false,
                  attributesToRetrieve: options.attributesToRetrieve || ['*'],
                  filters: (0, functions_2.getAlgoliaFilters)(wheres),
                  getRankingInfo: true,
                  hitsPerPage: options.nbParPage || defaultNbParPage,
                  page: options.page || 0,
                  responseFields: options.responseFields || ['*']
                }));

              case 7:
                searchResponse = _context6.sent;
                return _context6.abrupt("return", searchResponse);

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function search(_x7) {
        return _search.apply(this, arguments);
      }

      return search;
    }()
  }, {
    key: "ref",
    value: function ref(id) {
      return (0, firestore_1.doc)(this.getFirestore(), this.collectionName, id);
    }
  }, {
    key: "set",
    value: function () {
      var _set = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(id, values) {
        var ref, documentSnapshot, newData;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (firebase_1.auth.currentUser) {
                  _context7.next = 2;
                  break;
                }

                throw new Error("L'utilisateur doit être connecté pour mettre à jour un document");

              case 2:
                ref = (0, firestore_1.doc)(this.getCollectionRef(), id);
                _context7.next = 5;
                return (0, firestore_1.getDoc)(ref);

              case 5:
                documentSnapshot = _context7.sent;
                newData = this.clean(_objectSpread(_objectSpread({}, documentSnapshot.data()), values), true);
                return _context7.abrupt("return", (0, firestore_1.setDoc)(ref, newData));

              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function set(_x8, _x9) {
        return _set.apply(this, arguments);
      }

      return set;
    }()
  }, {
    key: "update",
    value: function update(id, values) {
      if (!firebase_1.auth.currentUser) {
        throw new Error("L'utilisateur doit être connecté pour mettre à jour un document");
      }

      var ref = (0, firestore_1.doc)(this.getCollectionRef(), id);
      return (0, firestore_1.updateDoc)(ref, _objectSpread({}, this.clean(values, true)));
    }
  }, {
    key: "clean",
    value: function clean(values, validate) {
      var _a, _b;

      var date = (0, dayjs_1.default)();

      if (validate && !this.allRequiredIsValid(values)) {
        throw new Error('Non validé');
      }

      var cleanData = (0, functions_1.removeUndefined)(_objectSpread(_objectSpread({}, values), {}, {
        createdAt: (values === null || values === void 0 ? void 0 : values.createdAt) || date.toISOString(),
        datetime: (values === null || values === void 0 ? void 0 : values.datetime) || parseInt(date.format('x'), 10),
        deleted: (_a = values === null || values === void 0 ? void 0 : values.deleted) !== null && _a !== void 0 ? _a : false,
        hidden: (values === null || values === void 0 ? void 0 : values.hidden) || false,
        updatedAt: date.toISOString(),
        updatedByUser: (_b = firebase_1.auth.currentUser) === null || _b === void 0 ? void 0 : _b.uid
      }));
      return _objectSpread(_objectSpread({}, cleanData), {}, {
        parent: (values === null || values === void 0 ? void 0 : values.parent) || ''
      });
    }
  }, {
    key: "watch",
    value: function watch(_next, options) {
      var _a;

      var constraints = [(0, firestore_1.where)('deleted', '==', false)];
      constraints = (0, functions_2.updateConstraints)(constraints, {
        orderDirection: (options === null || options === void 0 ? void 0 : options.orderDirection) || this.orderDirection,
        orderField: (options === null || options === void 0 ? void 0 : options.orderField) || this.orderField,
        wheres: (options === null || options === void 0 ? void 0 : options.wheres) ? (0, lodash_1.mergeWith)(options.wheres, this.wheres) : this.wheres
      });

      if (options === null || options === void 0 ? void 0 : options.startAfter) {
        constraints.push((0, firestore_1.startAfter)(options.startAfter));
      }

      constraints.push((0, firestore_1.limit)((_a = options === null || options === void 0 ? void 0 : options.limit) !== null && _a !== void 0 ? _a : parseInt(String(process.env.GATSBY_INNEDIT_WATCH_LIMIT), 10) || 250));
      return (0, firestore_1.onSnapshot)((0, firestore_1.query).apply(void 0, [this.getCollectionRef()].concat(_toConsumableArray(constraints))), {
        next: function next(querySnaphot) {
          _next(querySnaphot.docs.map(function (d) {
            return _objectSpread({
              id: d.id
            }, d.data());
          }));
        }
      });
    }
  }, {
    key: "watchById",
    value: function watchById(id, _next2) {
      var ref = (0, firestore_1.doc)(this.getCollectionRef(), id);
      return (0, firestore_1.onSnapshot)(ref, {
        next: function next(snapshot) {
          if (!snapshot || !snapshot.exists() || snapshot.get('deleted')) {
            return _next2(undefined);
          }

          var document = _objectSpread({
            id: id
          }, snapshot.data());

          return _next2(document, snapshot.metadata);
        }
      });
    }
  }, {
    key: "watchByIds",
    value: function watchByIds(ids, _next3) {
      var constraints = [(0, firestore_1.where)((0, firestore_1.documentId)(), 'in', ids)];
      var q = (0, firestore_1.query).apply(void 0, [this.getCollectionRef()].concat(constraints));
      return (0, firestore_1.onSnapshot)(q, {
        next: function next(snapshot) {
          return _next3(snapshot.docs.map(function (d) {
            return _objectSpread({
              id: d.id
            }, d.data());
          }));
        }
      });
    }
  }]);

  return Model;
}();

exports.default = Model;